// UI strings for the guided lesson path (app/src/lessonpath/, Axel 2026-10-10): the lesson text,
// each Kielioppi topic of the lesson on its own page, then the check's start screen; the bar at
// the foot of the phone (the parts as dots, "2/4", one button) and the "Luettu" button at the end
// of each part. Style: docs/FINNISH-STYLE.md (sinä, no jargon, only actionable text).
import { defineArea } from '../area';

export const lessonPathFi = {
  /** The bar as a landmark (screen readers). */
  bar: 'Oppitunnin osat',
  /** The bar's count, "2/4" (drawn), and the same in words for screen readers. */
  count: (i: number, n: number) => `${i}/${n}`,
  countLong: (i: number, n: number, part: string) => `Osa ${i}/${n}: ${part}`,
  /** A part's name in the bar and in the check's list of what to read first. */
  lessonText: 'Oppitunnin teksti',
  /** The kicker over a topic's page: "Oppitunti 1 · Kielioppi". */
  grammarKicker: (lesson: string) => `${lesson} · Kielioppi`,
  /** The dots' states (screen readers). */
  partRead: 'luettu',
  partUnread: 'lukematta',
  partHere: 'olet tässä',
  partPassed: 'läpäisty',
  /** The button at the end of a part, and in the bar while the part is unread. */
  done: 'Luettu',
  /** The bar's button before the end has been on screen (screen readers: why it waits). */
  doneWaits: 'Lue osa loppuun, niin voit merkitä sen luetuksi.',
  /** A part already marked read. */
  isRead: 'Olet lukenut tämän osan.',
  /** A topic on a Kielioppi § page already marked read. */
  topicIsRead: 'Olet lukenut tämän aiheen.',
  /** The bar's button once the part is read. */
  next: 'Seuraava',
  nextLong: (part: string) => `Seuraava: ${part}`,
};

export const lessonPathEn: typeof lessonPathFi = {
  bar: 'Parts of the lesson',
  count: (i, n) => `${i}/${n}`,
  countLong: (i, n, part) => `Part ${i}/${n}: ${part}`,
  lessonText: 'The lesson text',
  grammarKicker: (lesson) => `${lesson} · Grammar`,
  partRead: 'read',
  partUnread: 'not read yet',
  partHere: 'you are here',
  partPassed: 'passed',
  done: 'Read',
  doneWaits: 'Read the part to the end to mark it read.',
  isRead: 'You have read this part.',
  topicIsRead: 'You have read this topic.',
  next: 'Next',
  nextLong: (part) => `Next: ${part}`,
};

// Messages.lessonPath (i18n/area.ts: collected by area-registry.ts)
export const area = defineArea('lessonPath', lessonPathFi, lessonPathEn);
declare module '../area' {
  interface AreaMessages extends Record<typeof area.key, typeof lessonPathFi> {}
}
